import ProgramRequestDetail from 'components/global/ProgramRequestDetail/ProgramRequestDetail';

const VCProgramRequestDetail = () => <ProgramRequestDetail />;
export default VCProgramRequestDetail;
